import { render } from "./databaseConfig.vue?vue&type=template&id=eda6df32&ts=true"
import script from "./databaseConfig.vue?vue&type=script&lang=ts"
export * from "./databaseConfig.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__